/**
 * The business's name as staff read it: without an environment marker the setup added to the stored
 * name ("didto. Bistro (dev)" reads "didto. Bistro"). Settings shows and edits the stored name.
 */
export function displayBusinessName(name: string | null | undefined): string {
  return (name ?? '').replace(/\s*\((?:dev|development|staging)\)\s*$/i, '').trim();
}
